import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import map from 'lodash/map';
import forEach from 'lodash/forEach';
import max from 'lodash/max';
import filter from 'lodash/filter';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import { Doughnut } from 'react-chartjs-2';
import { browserHistory } from 'react-router';

// eslint-disable-next-line no-unused-vars
import pieceLabel from 'chart.piecelabel.js';

import Filters from '../../shared/filters/main';
import Calendar from '../../shared/calendar/main';
import SwitchStats from '../components/switch/main';
import CurrencySwitch from '../../shared/currency-switch';
import Switch from '../../shared/switch';
import MasterSwitch from '../components/master-switch/main';

lessRequire('modules/statistics/analytics/main.less');

import switchStatsLinkConfig from '../shared/switch-cfg.js';

const isRocket = process.env.CPA_ENV === 'rocket';

const agesLegend = !isRocket ? [
	{color: '#d62c2c', title: 'До 20'},
	{color: '#f36ab7', title: '20 - 24'},
	{color: '#833194', title: '25 - 31'},
	{color: '#7d47e9', title: '32 - 36'},
	{color: '#0090ff', title: '37 - 39'},
	{color: '#8d9ff3', title: '40 - 44'},
	{color: '#00dcff', title: '45 - 51'},
	{color: '#488609', title: '52 - 54'},
	{color: '#8caf00', title: '55 - 59'},
	{color: '#a5d500', title: '60 - 64'},
	{color: '#93f5b1', title: '65 - 69'},
	{color: '#f7d038', title: '70 - 74'},
	{color: '#f5a993', title: '75 - 81'},
	{color: '#ff8400', title: 'От 82'}
] : [
	{color: '#d62c2c', title: 'До 25'},
	{color: '#f36ab7', title: '26 - 35'},
	{color: '#a5d500', title: '36 - 45'},
	{color: '#7d47e9', title: '46 - 55'},
	{color: '#0090ff', title: '56 - 65'},
	{color: '#f7d038', title: '66 - 75'},
	{color: '#ff8400', title: 'От 76'}
];

const genAgesData = (d, intl) => {
	return d.showEmptyAgeChart ? {
		labels: [intl('Нет данных')],
		datasets: [{
			data: [1],
			borderWidth: 0,
			backgroundColor: '#f0f0f0'
		}]
	} : {
		labels: map(agesLegend, l => ` ${intl(l.title)}`),
		datasets: [{
			data: !isRocket ? [
				d.age_0_19, d.age_20_24, d.age_25_31, d.age_32_36, d.age_37_39, d.age_40_44, d.age_45_51,
				d.age_52_54, d.age_55_59, d.age_60_64, d.age_65_69, d.age_70_74, d.age_75_81, d.age_82
			] : [
				d.age_0_25, d.age_26_35, d.age_36_45, d.age_46_55, d.age_56_65, d.age_66_75, d.age_76
			],
			backgroundColor: map(agesLegend, l => l.color),
			borderWidth: 0
		}]
	};
};

const geoColors = [
	{minIndex: 0, color: '#ff8400'},
	{minIndex: 3, color: '#d62c2c'},
	{minIndex: 7, color: '#833194'},
	{minIndex: 12, color: '#a694ba'}
];

const options = d => {
	return {
		responsive: false,
		maintainAspectRatio: false,
		cutoutPercentage: 65,
		title: {display: false},
		legend: {display: false},
		tooltips: {
			enabled: !d.showEmptyAgeChart,
			mode: 'nearest'
		},
		pieceLabel: {
			render: d.showEmptyAgeChart ? 'label' : 'percentage',
			showZero: true,
			fontSize: 16,
			fontFamily: "'ProximaNova-Bold'",
			fontColor: 'white',
			precision: 0
		}
	};
};

const Main = renderViewsState(props => {
	const data = props.dataTable && props.dataTable.tableRows && props.dataTable.tableRows[0] || {};
	const geos = filter(data.countries, c => parseInt(c.cnt) > 0);
	const maxGeoCnt = max(map(geos, c => parseInt(c.cnt)));

	return (<Animate>
		<div className="container">
			<div className="container__content analytics">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">
						{props.intl('Статистика')}
					</h2>
					<SwitchStats links={switchStatsLinkConfig} intl={props.intl} />

					{!isRocket && (
						<div className="statistics-position__currency">
							<CurrencySwitch
								listOfCurrencies={props.listOfCurrencies}
								activeCurrency={props.activeCurrency}
								onSwitch={props.changeCurrency} />
						</div>
					)}

					{ props.isMaster &&
						<MasterSwitch options={props.masterSwitchConfig} onSwitch={props.applyMasterSwitch} intl={props.intl} />
					}
				</div>
				<div className="container__content-body">
					<div className="stats-wrap__control">
						<Filters {...props} filterApply={props.statisticsFilterApply} />
						<div className="stats-wrap__control-bottom clearfix">
							<button className="reset-btn" onClick={e => props.statsReset()} />
							<button className="submit-btn" onClick={e => props.statsApply()} >{props.intl('Применить')}</button>
							<div className="stats-wrap__control-calendar">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>
					</div>

					<div className="summary">
						<div className="section total">
							<div className="chart"></div>
							<div className="data">
								<span className="value font-proxima-nova-bold">{ data.total_conversions || 0}</span>
								<span className="title">{props.intl('Предварительных заказов')}</span>
							</div>
						</div>
						<div className="section accepted">
							<div className="chart"></div>
							<div className="data">
								<span className="value font-proxima-nova-bold">{ data.accepted_conversions || 0}</span>
								<span className="title">{props.intl('Подтвержденных заказов')}</span>
							</div>
						</div>
						<div className="section rejected">
							<div className="chart"></div>
							<div className="data">
								<span className="value font-proxima-nova-bold">{ data.declined_conversions || 0}</span>
								<span className="title">{props.intl('Отмененных заказов')}</span>
							</div>
						</div>
					</div>

					<div className="doughnut">
						<Doughnut data={genAgesData(data, props.intl)} options={options(data)} width={360} height={360} />
						<div className="legend">
							<span className="legend-title font-proxima-nova-bold">{props.intl('Возраст')}</span>
							{
								map(agesLegend, l => {
									return (<div className="legend-box" key={l.title}>
										<span className="box" style={{backgroundColor: l.color}} />
										<span className="title">{props.intl(l.title)}</span>
									</div>);
								})
							}
						</div>
						<div className="inner">
							<div className="male">
								<div className="data">
									<span className="value font-proxima-nova-bold">{ data.male || 0}</span>
									<span className="title">{props.intl('Мужчин')}</span>
								</div>
							</div>
							<div className="female">
								<div className="data">
									<span className="value font-proxima-nova-bold">{ data.female || 0}</span>
									<span className="title">{props.intl('Женщин')}</span>
								</div>
							</div>
						</div>
					</div>

					<div className="geo-stats">
						<table className="geos-table">
							{
								map(geos, (g, i) => {
									let backgroundColor = geoColors[0].color;
									forEach(geoColors, c => {
										backgroundColor = i >= c.minIndex ? c.color : backgroundColor;
									});
									return (
										<tr className="geo-row" key={i}>
											<td width={1}><span className="geo-name">{g.country}</span></td>
											<td>
												<div className="percent-line">
													<div className="fill"
														style={{
															backgroundColor,
															right: `${100 - g.cnt / maxGeoCnt * 100}%`
														}}
													/>
												</div>
											</td>
											<td width={1}><span className="geo-value">{g.cnt}</span></td>
										</tr>
									);
								})
							}
						</table>
					</div>
				</div>

				{
					process.env.CPA_ENV === 'everad' &&
					<div className="analytics-switch-compensate-margin">
						<Switch
							links={
								[{title: 'По моему аккаунту', url: 'statistics/analytics/'}]
									.concat(
										props.isNewRegisteredUser
											? []
											: [{title: 'Общая по системе', url: 'statistics/analytics/system'}]
									)
							}
							onSwitch={link => browserHistory.push(link)}
							intl={props.intl}
						/>
					</div>
				}
			</div>
		</div>
	</Animate>);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		affiliateData: selectors.getAffiliateData(state),
		isNewRegisteredUser: selectors.getIsNewRegisteredUser(state),
		dataTable: selectors.getDataTable(state),
		filters: selectors.getFilters(state),
		appliedFilters: selectors.getAppliedFilters(state),
		calendar: selectors.getCalendar(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		activeCurrency: selectors.getActiveCurrency(state),
		masterSwitchConfig: selectors.getMasterSwitchConfig(state),
		isMaster: selectors.getIsMasterStatus(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/analytics/main.js